<app-question-result *ngFor="let questionResult of questionResults; index as i"
                     [readonly]="readonly"
                     [testId]="testId"
                     [testResultId]="testResultId"
                     [testType]="testType"
                     [index]="i"
                     [questionResult]="questionResult"></app-question-result>
